import {Button, Checkbox, Label, ListBox, ListBoxItem, Popover, Select, SelectValue, Text} from "react-aria-components";
import {LuCheckSquare, LuChevronDown, LuSquare} from "react-icons/lu";
import React, {useEffect} from "react";
import "./DefaultMultiDropButton.css";
import WrappedWithErrorMessage from "../../ErrorMessage/ErrorMessage";

function DefaultMultiDropButton({name, emptyText, selected, options, disabled, label, className, onSelect, errorLoc, info}: {
    name: string;
    emptyText?: string;
    selected: string[];
    options: string[];
    disabled?: boolean;
    label: string;
    className?: string;
    onSelect: (newValue: string[]) => void;
    errorLoc?: string[];
    info?: React.ReactNode;
}) {
    const [isOpen, setIsOpen] = React.useState(false);
    const [selectedOptions, setSelectedOptions] = React.useState(selected);
    const [refresher, setRefresher] = React.useState(0);

    useEffect(() => {
        setSelectedOptions(selected);
    }, [selected]);

    let buttonText = emptyText
    if(selectedOptions.length > 0){
        buttonText = selectedOptions.join(", ")
    }

    function optionSelected(text) {
        let newSelected = selected
        if (newSelected === null || newSelected === undefined) {
            newSelected = []
        }
        const isSelected = selectedOptions.includes(text)
        if (isSelected) {
            const index = newSelected.indexOf(text)
            newSelected.splice(index, 1)
        } else {
            newSelected.push(text)
        }

        setSelectedOptions(newSelected)
        onSelect(newSelected)
        setRefresher(refresher + 1)
    }

    const optionElements = [];
    for (let i = 0; i < options.length; i++) {
        const isSelected = selectedOptions.includes(options[i])
        let checkbox = <LuSquare className="chechbox-icon" />
        if (isSelected) {
            checkbox = <LuCheckSquare className="checkbox-icon"/>
        }
        optionElements.push(<ListBoxItem
            key={options[i]+"_"+isSelected}
            aria-label={options[i]}
            onAction={() => optionSelected(options[i])}
            className="DropButtonListBoxItem"
       >
            {checkbox}
            {options[i]}
        </ListBoxItem>)
    }
    let labelName = "DefaultDropButtonLabel"
    if (disabled) {
        labelName = labelName + " disabled"
    }
    const labelElement = <Label className={labelName} id={label}>{label}</Label>

    className += " labeledDefaultMultiDropButton";

    let cl = "DefaultDropButton";
    if(className){
        cl = cl + " " + className
    }
    if (disabled) {
        cl = cl + " disabled"
    }

    const buttonTextElement = <SelectValue className="DropButtonText" slot="description">{buttonText}</SelectValue>
    return <div className={className}>
        <div className="label">
            {labelElement}
        </div>
        <WrappedWithErrorMessage errorLoc={errorLoc} disabled={disabled}>
            <Select
                className={cl}
                name={name}
                isDisabled={disabled}
                aria-label={label}
                slot="select"
            >
                <Button
                    aria-label={label}
                    onPress={() => {
                        setIsOpen(!isOpen);
                        return null
                    }}
                    slot="button"
                >
                    <Text className="DropButtonText" aria-label={label} slot="description">{buttonTextElement}</Text>
                    <LuChevronDown className="dropdown-arrow"/>
                </Button>
                <Popover
                    className="secondaryButtonDropdownPopover"
                    placement="bottom right"
                    isOpen={isOpen}
                    onOpenChange={(open) => setIsOpen(open)}
                >
                    <ListBox className="DropButtonListBox" aria-label={label} selectionMode="multiple">
                        {optionElements}
                    </ListBox>
                </Popover>
            </Select>
        </WrappedWithErrorMessage>
        {info}
    </div>
}

export default DefaultMultiDropButton;